<template>
  <div class="md-layout input-layout">
    <!-- Stage -->
    <validated-autocomplete-input
      class="md-layout-item md-size-33"
      :label="`Stage (${app_stages.length} available)`"
      v-model="status_change.stage"
      required
      :options="app_stages"
      force
    />

    <!-- Status -->
    <validated-autocomplete-input
      class="md-layout-item md-size-33"
      :label="`Status (${app_statuses.length} available)`"
      v-model="status_change.status"
      required
      :options="app_statuses"
      force
    />

    <!-- Reason -->
    <validated-autocomplete-input
      class="md-layout-item md-size-33"
      :label="`Reason (${app_status_reasons.length} available)`"
      v-model="status_change.reason"
      required
      :options="app_status_reasons"
      :disabled="disabledReason"
      force
    />

    <validated-autocomplete-input
      v-if="showBrokerDropdown"
      class="md-layout-item md-size-33"
      :label="`Broker`"
      v-model="status_change.brokerName"
      required
      :options="brokerNameArray"
      force
    />

    <!-- Comment -->
    <validated-text-input
      class="md-layout-item md-size-100"
      label="Comment / Additional Details"
      :required="status_change.stage == 'Broker' && status_change.status == 'Archive' && status_change.reason == 'Other'"
      v-model="status_change.comment"
    />
    <md-checkbox v-model="status_change.send_email" class="md-layout-item md-size-15">Send Email</md-checkbox>
    <div class="md-layout-item md-size-82">
        <md-field class="padding-10">
            <label>Email Body</label>
            <md-textarea v-model="status_change.email_body" md-autogrow :disabled="!status_change.send_email"></md-textarea>
        </md-field>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import filters from "@/components/utils/filters";
import ValidatedInputs from "@/components/ValidatedInput";

export default {
  components: {
    ...ValidatedInputs,
  },
  props: {
    value: {
      type: Object,
      required: true,
    },
    permissions: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      showBrokerDropdown: false,
      brokerNameArray: [],
      brokerArray: [],
      disabledReason: false,
    }
  },
  watch: {
    "status_change.stage"() {
      this.status_change.status = this.options.app_status_type[this.status_change.stage][0];
    },
    "status_change.status"(value) {
      this.status_change.reason =
        this.options.app_status_reason_type[this.status_change.stage][this.status_change.status][0];

      if (value === 'Fail'
      && !this.userHasRole('super-admin')
      && !this.userHasRole('Compliance Officer')) {
        this.disabledReason  = true;
        return;
      }
      this.disabledReason = false;
    },
    "status_change.brokerName"() {
      let broker = this.brokerArray.find(array => array.full_name === this.status_change.brokerName);
      this.status_change.broker = broker;
      console.log(this.status_change.brokerName);
    },
  },
  mounted() {
    this.status_change.email_body = `Your application has been updated: {{status}}\nReason: {{reason}}\nComment: {{comment}}`
  },
  computed: {
    // standard list of options from store
    ...mapGetters([
      "options",
      "userHasRole",
      "user",
    ]),

    // internal reference to the v-model on this component, handles incomeing and outgoing changes
    status_change: {
      get() {
        return this.value;
      },
      set(status_change) {
        console.log("EditLoanStatus.status_change UPDATED!");
        this.$emit("input", status_change);
      },
    },


    app_stages() {
      return Object.keys(this.options.app_status_type);
    },

    app_statuses() {
      if (this.status_change && this.status_change.stage) {
        return this.options.app_status_type[this.status_change.stage] || [];
      } else {
        return [];
      }
    },

    app_status_reasons() {
      if (this.status_change.status == "Live Transfer") {
        this.showBrokerDropdown = true;
        this.getAllInternalBroker();
      } else {
        this.showBrokerDropdown = false;
      }
      if (this.status_change && this.status_change.stage && this.status_change.status) {
        return (
          this.options.app_status_reason_type?.[this.status_change.stage]?.[this.status_change.status] || []
        );
      } else {
        return [];
      }
    },

    enable_archive_checkbox() {
      // TODO reimplement for status based in_progress flag
      if (this.status_change && this.permissions) {
        if (this.loan.archived) {
          return this.permissions["un-archive"];
        } else {
          return this.permissions["archive"];
        }
      }
      return false;
    },
  },
  methods: {
    // make all filters available as methods
    ...filters,
    async getAllInternalBroker () {
      try {
        const response = await axios.get('/api/v1/brokers/getAllInternalBrokers');
        //Exclude Internal Pink Panther from the list
        const allowBrokerArray =  response.data.filter(broker => broker.user_pod_id != "612");
        this.brokerArray = allowBrokerArray;
        this.brokerNameArray = allowBrokerArray.map(item => item.full_name);
      } catch (err) {
        console.log(err);
      }
    },
  },
  filters: {
    // make all filters available as filters
    ...filters,
  },
  async beforeCreate() {
    const params = {
      types: [
        'app_status_type',
        'app_status_reason_type',
      ],
    }
    await this.$store.dispatch('fetch_types', { params });
  },
};
</script>
<style scoped lang="scss">
    .padding-10 {
        padding: 10px !important;
    }
</style>
